// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__-xhlf","footer":"ReportModalFilter_footer__1WsQD"};